import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { WrapperCabinetComponent } from './wrapper/wrapper.component';
import { HeaderCabinetComponent, HeaderLicenseStatus } from './header/header.component';
import { SidenavCabinetComponent } from './sidenav/sidenav.component';
import { ContentCabinetComponent } from './content/content.component';
import { WrapperContentCabinetComponent } from './wrapper-content/wrapper-content.component';
import { FooterCabinetComponent } from './footer/footer.component';
import { MenuCabinetComponent } from '../menus/menu/menu.component';
import { MenuItemCabinetComponent } from '../menus/menu-item/menu-item.component';
import { MenuHeadingCabinetComponent } from '../menus/menu-heading/menu-heading.component';
import { MenuSectionCabinetComponent } from '../menus/menu-section/menu-section.component';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';

export interface MenuItem {
  label: string;
  icon: string;
  route: string;
  badge?: number;
}

export interface MenuSection {
  heading?: string;
  items: MenuItem[];
}

@Component({
  selector: 'app-layout',
  standalone: true,
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    WrapperCabinetComponent,
    HeaderCabinetComponent,
    SidenavCabinetComponent,
    ContentCabinetComponent,
    WrapperContentCabinetComponent,
    FooterCabinetComponent,
    MenuCabinetComponent,
    MenuItemCabinetComponent,
    MenuHeadingCabinetComponent,
    MenuSectionCabinetComponent,
    SafeHtmlPipe
  ]
})
export class LayoutComponent {
  menuSections = input<MenuSection[]>([]);
  shouldShowCompanyLogo = input<boolean>(false);
  currentCompany = input<{ name: string; logo_url?: string; owner_user?: { email: string } } | null>(null);
  licenseStatus = input<HeaderLicenseStatus | null>(null);
  pluginConnected = input<boolean>(false);

  isSidebarCollapsed = false;
  isSidebarOpen = false;

  toggleSidebar = output<void>();
  badgeClick = output<void>();

  get effectiveSidebarCollapsed(): boolean {
    if (typeof window !== 'undefined' && window.innerWidth < 1024) {
      return false;
    }
    return this.isSidebarCollapsed;
  }

  onToggleSidebar(): void {
    if (typeof window !== 'undefined' && window.innerWidth < 1024) {
      this.isSidebarOpen = !this.isSidebarOpen;
    } else {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    }
    this.toggleSidebar.emit();
  }

  closeSidebar(): void {
    this.isSidebarOpen = false;
  }
}
